import { useEffect, useRef, useState } from 'react';
import { useBlocker } from 'react-router-dom';

/** Each independently saved form owns its draft; saving a barcode must not clear a price draft. */
export function useProductDraft(busy: boolean) {
  const headingRef = useRef<HTMLHeadingElement>(null);
  useEffect(() => {
    headingRef.current?.focus({ preventScroll: true });
    window.scrollTo(0, 0);
  }, []);
  const [drafts, setDrafts] = useState<ReadonlySet<string>>(new Set());
  const dirty = drafts.size > 0;
  const blocker = useBlocker(dirty || busy);
  useEffect(() => {
    const unload = (event: BeforeUnloadEvent) => {
      if (dirty || busy) { event.preventDefault(); event.returnValue = ''; }
    };
    const logout = (event: Event) => {
      if (busy || (dirty && !window.confirm('Discard unsaved product changes and log out?'))) event.preventDefault();
    };
    window.addEventListener('beforeunload', unload);
    window.addEventListener('techpos:before-logout', logout);
    return () => { window.removeEventListener('beforeunload', unload); window.removeEventListener('techpos:before-logout', logout); };
  }, [dirty, busy]);
  const mark = (name: string) => setDrafts(current => new Set([...current, name]));
  const saved = (name: string) => setDrafts(current => new Set([...current].filter(item => item !== name)));
  const warning = blocker.state === 'blocked' ? <div className="banner product-leave-warning" role="alert">
    <p>{busy ? 'Please wait for the current save to finish before leaving.' : 'You have unsaved product changes. Discard them and leave this page?'}</p>
    <button type="button" onClick={() => blocker.reset()}>Stay on page</button>
    <button type="button" disabled={busy} onClick={() => blocker.proceed()}>Discard and leave</button>
  </div> : null;
  return { mark, saved, warning, headingRef };
}
